<template>
  <section class="section-padding container-padding">
    <div class="p-8 bg-white rounded-md border max-w-3xl mx-auto">
      <h1 class="w-full text-center mb-2 text-gray-900">
        District Selection
      </h1>

      <p class="w-full text-center mb-8">
        For which district are you capturing data?
      </p>

      <div class="border rounded-md">
        <template v-if="authStore.user.districts">
          <button
            v-for="district in authStore.user.districts"
            :key="district.id"
            class="block w-full text-center p-2 cursor-pointer hover:bg-secondary-alt-subtle hover:text-secondary-alt"
            :class="{ 'bg-secondary-alt-subtle text-secondary-alt font-semibold': district.current }"
            aria-current="true"
            @click="handleChangeDistrict(district)"
            @mouseover="hoveredDistrict = district.id"
            @mouseleave="hoveredDistrict = null"
          >
            <span class="relative w-fit">
              <span class="pr-2">{{ district.name }}</span>
              <span class="district-label">
                <transition>
                  <span
                    v-show="hoveredDistrict === district.id && hoveredDistrict !== district.current"
                    class="absolute right-0 translate-x-full rounded border border-primary bg-primary whitespace-nowrap text-white px-1 text-xs font-medium py-[2px]"
                  >
                    Switch to this District
                  </span>
                </transition>
              </span>
            </span>
          </button>
        </template>
      </div>
    </div>
  </section>
</template>

<script setup>
import { HttpStatusCode } from 'axios';
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore, useToastStore } from '@/store/index.js';
import { useHttp } from '@/composables/index.js';

const authStore = useAuthStore();
const toastStore = useToastStore();
const router = useRouter();
const loading = ref(false);
const loadingDistrictId = ref(null);
const hoveredDistrict = ref(null);

const handleChangeDistrict = async (district) => {
  loading.value = true;
  loadingDistrictId.value = district.id;

  const response = await useHttp().put('/profile/district', { currentDistrict: district.id });

  if (response.statusCode === HttpStatusCode.Ok) {
    authStore.user = response.data;

    const currentDistrict = authStore.user.districts.find(district => district.current);

    await router.push({ name: 'app_plan_list', params: { district: currentDistrict.id } });
  } else {
    toastStore.type = 'danger';
    toastStore.message = response.exception;
  }

  loading.value = false;
  loadingDistrictId.value = null;
};

</script>

<style scoped>
/* we will explain what these classes do next! */
.v-enter-active,
.v-leave-active {
  transition: opacity 0.2s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

@media (max-width: 992px) {
  .district-label {
    display: none;
  }
}
</style>
